import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'signed'
})
export class SignedNumberPipe implements PipeTransform {
    transform(value: number | string | null | undefined) {
        if (typeof value == 'string') return value;
        if (value === null || value === undefined) return null;

        return ((value < 0) ? '' : '+') + value;
    }
}